<div
  class="relative p-[10px] border-2 border-solid border-transparent transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary w-[100%] bg-white cursor-pointer"
  [id]="'pagemodule' + content.id"
  [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }"
  [ngClass]="{
    '!border-2 !border-solid !border-primary': isSelectedModule,
  }">
  <div>
    <div
      class="text-center font-bold mb-5"
      [attr.style]="buildStyle('text', items[0].styles?.text)">
      {{ items[0].value.text }}
    </div>
    <div class="flex gap-6 items-center justify-center flex-wrap">
      @for (icon of items; track icon) {
        @if (icon?.value?.icon) {
          <a target="_blank" [href]="icon?.value?.link">
            <i
              [class]="icon.value.icon"
              [attr.style]="buildStyle('icon', icon?.styles?.icon)"
            ></i>
          </a>
        }
        @else if (icon?.value?.url) {
          <a [href]="icon?.value?.link"
            ><img
              [src]="icon?.value?.url"
              class="w-[40px] h-[40px] rounded-full object-cover"
          /></a>
        }
      }
    </div>
  </div>
</div>
